enum ViewType {
  Card = 'card',
  Row = 'row',
}

export default ViewType;
